import { Facebook, Twitter, Instagram, Youtube, Mail, Phone } from 'lucide-react';
import gpt from "../assets/ChatGPT.png"
import {
  MECCA_TO_CHRIST_LOGO,
  MECCA_TO_CHRIST_NAME,
  MECCA_TO_CHRIST_URL,
} from "../data/ministry";

function Footer() {
  return (
    <footer className="bg-gray-900 text-white mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center mb-4">
              <img src={gpt} alt='img' width={120} height={120} className='gpt-image-footer'/>
              {/* <div className="text-2xl mr-3">🕌</div> */}
              <span className="text-xl font-bold text-yellow-400">Mecca Prayer House</span>
            </div>
            <p className="text-gray-400">
              Providing accurate prayer times for Muslims in North America since 2023.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="/" className="text-gray-400 hover:text-yellow-400 transition-colors">Home</a></li>
              <li><a href="/about" className="text-gray-400 hover:text-yellow-400 transition-colors">About Us</a></li>
              <li><a href="/" className="text-gray-400 hover:text-yellow-400 transition-colors">USA Prayer Times</a></li>
              <li><a href="/" className="text-gray-400 hover:text-yellow-400 transition-colors">Canada Prayer Times</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li><a href="https://www.islamicfinder.org/world/colombia/3682393/florida-prayer-times/" target='_blank' rel="noreferrer"  className="text-gray-400 hover:text-yellow-400 transition-colors">Islamic Calendar</a></li>
              <li><a href="mailto:info@meccatochrist.org" target='_blank' rel="noreferrer"  className="text-gray-400 hover:text-yellow-400 transition-colors">Contact</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Connect With Us</h3>
            <div className="flex space-x-4 mb-6">
              <a href="https://www.facebook.com/mecca2christ" target="_blank" rel="noreferrer" className="bg-gray-800 p-2 rounded-lg hover:bg-yellow-400 transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="https://x.com/mecca2christ" target="_blank" rel="noreferrer" className="bg-gray-800 p-2 rounded-lg hover:bg-yellow-400 transition-colors" >
                <Twitter className="h-5 w-5" />
              </a>
              <a href="https://www.instagram.com/mecca_to_christ/" target="_blank" rel="noreferrer" className="bg-gray-800 p-2 rounded-lg hover:bg-yellow-400 transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://www.youtube.com/@MBBs.Academy777" target="_blank" rel="noreferrer" className="bg-gray-800 p-2 rounded-lg hover:bg-yellow-400 transition-colors">
                <Youtube className="h-5 w-5" />
              </a>
               <a href="mailto:info@meccatochrist.org" target="_blank" rel="noreferrer" className="bg-gray-800 p-2 rounded-lg hover:bg-yellow-400 transition-colors">
                <Mail className="h-5 w-5" />
              </a>
               <a href="https://wa.me/+17477772758?text=Hello%20there!" target="_blank" rel="noreferrer" className="bg-gray-800 p-2 rounded-lg hover:bg-yellow-400 transition-colors">
                <Phone className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Parent ministry — the mark is white, so it only reads on this band */}
        <div className="mt-12 flex flex-col items-center gap-3 border-t border-gray-800 pt-8 text-center">
          <span className="text-[11px] font-semibold uppercase tracking-widest text-gray-500">
            A ministry of
          </span>
          <a
            href={MECCA_TO_CHRIST_URL}
            target="_blank"
            rel="noopener noreferrer"
            title={MECCA_TO_CHRIST_NAME}
            className="transition-opacity hover:opacity-80"
          >
            <img
              src={MECCA_TO_CHRIST_LOGO}
              alt={MECCA_TO_CHRIST_NAME}
              width={1080}
              height={443}
              loading="lazy"
              className="block h-auto w-[190px] max-w-full"
            />
          </a>
          <p className="mt-4 text-sm text-gray-400">
            © {new Date().getFullYear()} Mecca Prayer House · a ministry of{' '}
            <a
              href={MECCA_TO_CHRIST_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="underline transition-colors hover:text-yellow-400"
            >
              Mecca to Christ International
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;